<template>
    <div>
      <!-- 触发按钮 -->
      <el-button type="primary" @click="showDialog">创建发货单</el-button>
  
      <!-- 订单选择弹窗 -->
      <el-dialog
        title="选择订单"
        :visible.sync="dialogVisible"
        width="70%"
        :before-close="handleClose"
      >
        <div class="order-select-container">
          <!-- 搜索和过滤区域 -->
          <div class="filter-area">
            <el-input
              v-model="searchQuery"
              placeholder="搜索订单号/客户名称"
              clearable
              style="width: 300px"
              @clear="handleSearchClear"
              @keyup.enter.native="handleSearch"
            >
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
            
            <div class="filter-options">
              <el-radio-group v-model="selectMode" @change="handleModeChange">
                <el-radio-button label="single">单选</el-radio-button>
                <el-radio-button label="multiple">多选</el-radio-button>
              </el-radio-group>
              
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="handleDateChange"
              ></el-date-picker>
            </div>
          </div>
          
          <!-- 订单表格 -->
          <el-table
  ref="orderTable"
  :data="filteredOrders"
  border
  style="width: 100%"
  height="400"
  @select="handleSelect"
  @select-all="handleSelectAll"
>
          <el-table-column
    v-if="selectMode === 'single'"
    label="选择"
    width="55"
  >
    <template slot-scope="scope">
      <el-radio
        v-model="selectedOrderId"
        :label="scope.row.order_id"
        @change="handleRadioChange(scope.row)"
      >&nbsp;</el-radio>
    </template>
  </el-table-column>
  
  <!-- 多选模式下的复选框列 -->
  <el-table-column
    v-if="selectMode === 'multiple'"
    type="selection"
    width="55"
  ></el-table-column>
            
  <el-table-column
    prop="order_no"
    label="订单号"
    width="180"
  ></el-table-column>
            
            <el-table-column
              prop="user.nickName"
              label="客户名称"
              width="150"
            ></el-table-column>
            
            <el-table-column
            prop="product"
            label="产品名称">
            <template slot-scope="{row}">
            <div v-if="row.product && row.product.length">
            {{ row.product.slice(0, 2).map(item => item.product_name).join('，') }}
            <span v-if="row.product.length > 2" style="color: #999">
            （+{{ row.product.length - 2 }}个）
            </span>
            </div>
            </template>
            </el-table-column>

            <el-table-column
            prop="product"
             width="70"
            label="产品数量">
            <template slot-scope="{row}">
            <div v-if="row.product && row.product.length">
            {{ row.product.slice(0, 2).map(item => item.total_num).join('，') }}
            <span v-if="row.product.length > 2" style="color: #999">
            （+{{ row.product.length - 2 }}个）
            </span>
            </div>
            </template>
            </el-table-column>
            
            <el-table-column
              prop="user.mobile"
              label="客户电话"
              width="100"
              align="center"
            ></el-table-column>
          
            
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="180"
            ></el-table-column>
            
          </el-table>
          
          <!-- 分页 -->
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalOrders"
            ></el-pagination>
          </div>
        </div>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmSelection">确 定</el-button>
        </span>
      </el-dialog>
      
      <!-- 拼柜选择弹窗 -->
      <el-dialog
        title="拼柜信息"
        :visible.sync="mergeDialogVisible"
        width="40%"
      >
        <div class="merge-container">
          <el-form :model="mergeForm" label-width="120px">
            <el-form-item label="是否拼柜">
              <el-radio-group v-model="mergeForm.isMerge">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
            
            <el-form-item label="拼柜立方数" v-if="mergeForm.isMerge===1">
              <el-input-number
                v-model="mergeForm.mergeVolume"
                :min="0.1"
                :step="0.1"
                :precision="2"
                controls-position="right"
              ></el-input-number>
              <span style="margin-left: 10px;">m³</span>
            </el-form-item>
            
            <el-form-item label="备注" v-if="mergeForm.isMerge===1">
              <el-input
                type="textarea"
                :rows="3"
                v-model="mergeForm.remark"
                placeholder="请输入拼柜备注信息"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="mergeDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmMerge">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import OrderApi from '@/api/order.js'
  export default {
    name: 'OrderSelectDialog',
    props: {
      // 可以传入默认选中的订单
      selectedOrders: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        dialogVisible: false,
        mergeDialogVisible: false,
        searchQuery: '',
        selectMode: 'single', // 'single' or 'multiple'
        dateRange: [],
        currentPage: 1,
        pageSize: 10,
        totalOrders: 0,
        orders: [],
        selectedOrderId: null,
        selectedOrderList: [],
        mergeForm: {
          isMerge: false,
          mergeVolume: 1,
          remark: ''
        }
      }
    },
    computed: {
      filteredOrders() {
        // 这里可以添加更复杂的过滤逻辑
        return this.orders.filter(order => {
          const matchesSearch = this.searchQuery === '' || 
            order.order_no.includes(this.searchQuery) || 
            order.user.nickName.includes(this.searchQuery);
          
          const matchesDate = this.dateRange.length === 0 || 
            (new Date(order.create_time) >= new Date(this.dateRange[0]) && 
            (new Date(order.create_time) <= new Date(this.dateRange[1])));
          
          return matchesSearch && matchesDate;
        });
      }
    },
    methods: {
      showDialog() {
        this.dialogVisible = true;
        this.fetchOrders();
      },
      
      handleClose(done) {
        this.$confirm('确认关闭？未保存的选择将丢失', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          done();
        }).catch(() => {});
      },
      
      fetchOrders() {
        OrderApi.orderlist()
        .then(res => {
          if(res.data.list.data){
            this.orders = res.data.list.data
            this.totalOrders = this.orders.length;
          }else {
            this.orders = res.data.list
            this.totalOrders = this.orders.length;
          }
          
        })
        setTimeout(() => {
          // this.orders = [
          //   {
          //     id: 1,
          //     orderNo: 'ORD20230001',
          //     customerName: '客户A',
          //     productName: '产品A',
          //     quantity: 100,
          //     volume: 2.5,
          //     createTime: '2023-01-15 10:30:00',
          //     status: 'pending',
          //     statusText: '待处理'
          //   },
          //   {
          //     id: 2,
          //     orderNo: 'ORD20230002',
          //     customerName: '客户B',
          //     productName: '产品B',
          //     quantity: 50,
          //     volume: 1.8,
          //     createTime: '2023-01-16 14:20:00',
          //     status: 'confirmed',
          //     statusText: '已确认'
          //   },
          //   {
          //     id: 3,
          //     orderNo: 'ORD20230003',
          //     customerName: '客户C',
          //     productName: '产品C',
          //     quantity: 200,
          //     volume: 3.2,
          //     createTime: '2023-01-17 09:15:00',
          //     status: 'shipped',
          //     statusText: '已发货'
          //   },
          //   {
          //     id: 4,
          //     orderNo: 'ORD20230004',
          //     customerName: '客户A',
          //     productName: '产品D',
          //     quantity: 75,
          //     volume: 2.1,
          //     createTime: '2023-01-18 16:45:00',
          //     status: 'completed',
          //     statusText: '已完成'
          //   },
          //   {
          //     id: 5,
          //     orderNo: 'ORD20230005',
          //     customerName: '客户D',
          //     productName: '产品E',
          //     quantity: 120,
          //     volume: 2.8,
          //     createTime: '2023-01-19 11:30:00',
          //     status: 'pending',
          //     statusText: '待处理'
          //   }
          // ];
         
          
          // 设置默认选中项
          this.$nextTick(() => {
            if (this.selectedOrders.length > 0) {
              this.selectedOrders.forEach(orderId => {
                const order = this.orders.find(o => o.id === orderId);
                if (order) {
                  this.$refs.orderTable.toggleRowSelection(order, true);
                }
              });
            }
          });
        }, 500);
      },
      
      handleSearch() {
        this.currentPage = 1;
        this.fetchOrders();
      },
      
      handleSearchClear() {
        this.searchQuery = '';
        this.handleSearch();
      },

      handleModeChange() {
    this.selectedOrderList = [];
    this.selectedOrderId = null;
    this.$refs.orderTable.clearSelection();
  },
      
      // handleModeChange() {
      //   this.selectedOrderList = [];
      //   this.$refs.orderTable.clearSelection();
      // },
      
      handleDateChange() {
        this.currentPage = 1;
        this.fetchOrders();
      },
      
      handleSelectionChange(selection) {
        this.selectedOrderList = selection;
      },


      handleSelect(selection, row) {    
        
  if (this.selectMode === 'single') {
    this.$refs.orderTable.clearSelection();
    this.$refs.orderTable.toggleRowSelection(row, true);
    this.selectedOrderList = [row];  // 确保单选模式下 selectedOrderList 只包含当前选中的行
  } else {
    this.selectedOrderList = selection;  // 多选模式下直接使用 selection
  }
},

handleSelectAll(selection) {
  if (this.selectMode === 'single' && selection.length > 0) {
    this.$refs.orderTable.clearSelection();
    this.$refs.orderTable.toggleRowSelection(selection[0], true);
    this.selectedOrderList = [selection[0]];
  } else {
    this.selectedOrderList = selection;  // 多选模式下直接使用 selection
  }
},

handleRadioChange(row) {
  this.selectedOrderId = row.order_id;
  this.selectedOrderList = [row]; // 同步更新 selectedOrderList
  },

  confirmSelection() {
  // 单选模式验证
  if (this.selectMode === 'single' && !this.selectedOrderId) {
    this.$message.warning('请选择一条订单');
    return;
  }

  // 多选模式验证
  if (this.selectMode === 'multiple' && this.selectedOrderList.length === 0) {
    this.$message.warning('请至少选择一条订单');
    return;
  }

  // 如果是单选模式，确保 selectedOrderList 有值
  if (this.selectMode === 'single' && this.selectedOrderId) {
    const selectedOrder = this.orders.find(order => order.id === this.selectedOrderId);
    if (selectedOrder) {
      this.selectedOrderList = [selectedOrder];
    }
  }

  // 显示拼柜选择弹窗
  this.mergeDialogVisible = true;

  // 计算总立方数
  const totalVolume = this.selectedOrderList.reduce((sum, order) => sum + order.volume, 0);
  this.mergeForm.mergeVolume = parseFloat(totalVolume.toFixed(2));
},
      
      handleSizeChange(size) {
        this.pageSize = size;
        this.fetchOrders();
      },
      
      handleCurrentChange(page) {
        this.currentPage = page;
        this.fetchOrders();
      },
      
      getStatusType(status) {
        const map = {
          pending: 'warning',
          confirmed: 'primary',
          shipped: 'info',
          completed: 'success',
          canceled: 'danger'
        };
        return map[status] || '';
      },
      
      confirmMerge() {
        
      OrderApi.createWithProducts({
        supply_id: this.selectedOrderList[0].supply_ids, 
        gz_type: this.mergeForm.isMerge ? 1 : 2,
        warehouse_id: 1,
        products: JSON.stringify(this.selectedOrderList[0].product.map(p => ({
          product_id: p.product_id,
          order_id:p.order_id,
          sku_id: p.product_sku_id, 
          price: parseFloat(p.total_price), 
          num: parseInt(p.total_num), 
          cube: parseFloat(mergeForm.mergeVolume || 0) 
        })))
      })
        .then((res)=>{
          console.log(res.data);
          
        })
        
        // 关闭弹窗
        this.dialogVisible = false;
        this.mergeDialogVisible = false;
        
        // 重置表单
        this.mergeForm = {
          isMerge: false,
          mergeVolume: 1,
          remark: ''
        };
        
        this.$message.success('选择成功');
      }
    }
  }
  </script>
  
  <style scoped>
  .order-select-container {
    padding: 10px;
  }
  
  .filter-area {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .filter-options {
    display: flex;
    align-items: center;
  }
  
  .filter-options > * {
    margin-left: 15px;
  }
  
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  
  .merge-container {
    padding: 10px 20px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/order/OrderSelectDialog.vue